import times from 'lodash/times'
import { decomposeColor } from '@material-ui/core/styles/colorManipulator'

/**
 * this function determines if the given color is "dark"
 * @param {string} - color - the color string to check, in RGB format (#rrggbb, rgb(r,g,b) or rgba(r,g,b,a)
 * @param {number} - threshold - the threshold to use for "dark", defaults to midpoint 128 (0-255)
 * @return {boolean} - whether the color was dark
 */
export function isDarkColor(color: string, threshold = 128): boolean {
  const decomposed = decomposeColor(color)
  if (decomposed.type.includes('rgb')) {
    const colorSum = times(3).reduce(
      (total: number, i: number): number => total + decomposed.values[i],
      0
    )
    return colorSum / 3 < threshold
  }
  return false
}

export default isDarkColor
